// AdminDashboard.jsx
import React, { useEffect, useState } from "react";

import dashboardHero from '../../assets/images/dashboard-hero.jpg'

import PageHero from "../../components/adminPage/PageHero";
import Stats from "../../components/adminPage/dashboard/Stats";
import RecentMessages from "../../components/adminPage/dashboard/RecentMessages";
import NewSubcribers from "../../components/adminPage/dashboard/NewSubcribers";
import SubscribersActivity from "../../components/adminPage/dashboard/SubscribersActivity";
//import { useHttpClient } from "../../hooks/http-hook";

export default function AdminDashboard({
    className,
    recentMessages,
    newMessages,
    newSubscribers,
    subscribers,
    subscriberActivity
}) {

    return (
        <div className={`min-h-screen bg-background pb-20 ${className}`}>
            <PageHero
                pageTitle="Admin Panel"
                pageSubtitle="Son güncel verileriniz burada"
            />
            {/* Main Content */}
            <div className="max-w-7xl mx-auto px-6 pt-8">
                {/* Stat Cards */}
                <Stats subscribers={subscribers} newMessages={newMessages} />

                {/* Main grid sections */}
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">


                    {/* Recent Messages */}
                    <RecentMessages recentMessages={recentMessages} />

                    {/* New Subscribers */}
                    <NewSubcribers subcscribers={newSubscribers} />

                    {/* Subscriber Activity Heatmap */}

                    <SubscribersActivity subscriberActivity={subscriberActivity} />
                </div>
            </div>
        </div>
    );
}
